import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  checkSessionUrl,
  loginUrl,
  logoutUrl,
  sessionCookieUrl,
} from '@app/definition/API';
import fetchWorkspaces from '../workspaces/fetchThunk';
import clearWorkspace from '../workspaces/clearThunk';
import {
  WorkspaceDetailsInterface,
  WorkspacesStateInterface,
} from '../../session/types';
import setWorkspace from '../workspaces/setThunk';
import {
  getInitialState,
  getSessionExtraReducers,
  getSessionReducers,
  getSessionThunks,
  SessionStateI,
} from '../../session/sessionSlice';
import setUserData from './setUserDataThunk';

export interface BusinessSessionStateI extends SessionStateI {
  workspaces: WorkspacesStateInterface;
}

export const sessionThunks = getSessionThunks(setUserData, {
  csrf: sessionCookieUrl,
  check: checkSessionUrl,
  login: loginUrl,
  logout: logoutUrl,
});

const initialState: BusinessSessionStateI = {
  ...getInitialState(),
  workspaces: {
    current: null,
    loaded: false,
    list: [],
  },
};

export default createSlice({
  name: 'businessSession',
  initialState,
  reducers: {
    ...getSessionReducers<BusinessSessionStateI>(),
    setCreditCardAttached: (state): void => {
      if (state.workspaces.current) {
        state.workspaces.current.company.stripe_card = true;
      }
    },
  },
  extraReducers: {
    ...getSessionExtraReducers(sessionThunks),
    [fetchWorkspaces.fulfilled.type]: (
      state,
      action: PayloadAction<WorkspaceDetailsInterface[]>
    ): void => {
      state.workspaces.loaded = true;
      state.workspaces.list = action.payload;
    },
    [setWorkspace.fulfilled.type]: (
      state,
      action: PayloadAction<WorkspaceDetailsInterface>
    ): void => {
      state.workspaces.current = action.payload;
    },
    [clearWorkspace.fulfilled.type]: (state): void => {
      state.workspaces.loaded = false;
      state.workspaces.list = [];
      state.workspaces.current = null;
    },
  },
});
